import { render, staticRenderFns } from "./Consults.vue?vue&type=template&id=f704aee2&"
import script from "./Consults.vue?vue&type=script&lang=js&"
export * from "./Consults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports